import { isDefinedArray } from "et3-type-guards";

import i18n from "../../../constants/i18n";
import {
  APPROVAL_LIMIT,
  COUTRIES_GROUP_PICKER_ENTRIES
} from "../../../constants/picker-entries-constants";
import Et3Button from "../../../core/et3-button";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Picker from "../../../core/et3-input/et3-picker";
import getApproveRejectStore from "../../../stores/approval-reject-store";
import { TEt3PickerSingleValue } from "../../../TypesNEW";
import {
  FILTERS_BUTTON_TOP_OFFSET,
  FILTERS_FIELD_GAP,
  FILTERS_ROW_GAP
} from "./approve-reject-form-constants";

const ApproveRejectForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX, unitY } = theme;
  const store = getApproveRejectStore();
  const isDataExist = isDefinedArray(store.approvalData.get());

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      width={0}
      height={0}
      color={colors.all.transparent}
      style={{
        width: "100%",
        minWidth: 0,
        flexWrap: "wrap",
        gap: `${FILTERS_ROW_GAP * unitY}px ${FILTERS_FIELD_GAP * unitX}px`
      }}
      onClick={() => {}}
    >
      <Et3Picker
        label={i18n.get("COUNTRY_CREATED_FROM")}
        options={COUTRIES_GROUP_PICKER_ENTRIES}
        onChoose={(value: TEt3PickerSingleValue) => {
          store.setApproveRejectCreatedFromType(value);
        }}
        value={store.createdFromType.get()}
        style={{}}
        isMultiple={false}
        onEnter={() => {}}
        onClick={() => {}}
        containerStyle={{}}
      />
      <Et3Picker
        label={i18n.get("LIMIT")}
        options={APPROVAL_LIMIT}
        value={store.selectedLimit.get()}
        onChoose={(value: TEt3PickerSingleValue) => {
          store.setSelectedLimit(value);
        }}
        isMultiple={false}
        style={{}}
        onEnter={() => {}}
        onClick={() => {}}
        containerStyle={{}}
      />
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="center"
        withShadow={false}
        width={0}
        height={0}
        color={colors.all.transparent}
        style={{
          width: "auto",
          minWidth: 0,
          flexShrink: 0,
          marginTop: FILTERS_BUTTON_TOP_OFFSET * unitY,
          gap: FILTERS_FIELD_GAP * unitX
        }}
        onClick={() => {}}
      >
        <Et3Button
          type="GET"
          isEnabled={true}
          onClick={async () => await store.getAwaitingApprovalData()}
          size="MEDIUM"
          text="GET"
        />
        <Et3Button
          type="REJECT"
          isEnabled={isDataExist}
          onClick={async () => await store.cleanPool()}
          size="MEDIUM"
          text="CLEAN_POOL"
        />
      </ET3Div>
    </ET3Div>
  );
});

export default ApproveRejectForm;
